import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Error boundary to prevent white screen crashes
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('App error boundary caught:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ background: '#000', color: '#fff', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px', textAlign: 'center' }}>
          <h2 style={{ color: '#f59e0b', marginBottom: '12px' }}>Something went wrong</h2>
          <p style={{ color: '#9ca3af', marginBottom: '20px' }}>The audio player hit an issue. Try refreshing.</p>
          <button onClick={() => window.location.reload()} style={{ background: '#f59e0b', color: '#000', border: 'none', padding: '10px 24px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
import { AudioProvider } from './context/AudioContext';
import { CartProvider } from './context/CartContext';
import { ThemeProvider } from './context/ThemeContext';
import { FontProvider } from './context/FontContext';
import { AuthProvider } from './context/AuthContext';
import { AdminProvider } from './context/AdminContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AudioPlayer from './components/AudioPlayer';
import Cart from './components/Cart';
import WelcomePopup from './components/WelcomePopup';
import Landing from './pages/Landing';
import Home from './pages/Home';
import BeatStore from './pages/BeatStore';
import SoundKits from './pages/SoundKits';
import Discography from './pages/Discography';
import MerchStore from './pages/MerchStore';
import Collaborate from './pages/Collaborate';
import MixMaster from './pages/MixMaster';
import Contact from './pages/Contact';
import Settings from './pages/Settings';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <FontProvider>
          <AuthProvider>
            <AdminProvider>
              <AudioProvider>
                <CartProvider>
                  <div className="App min-h-screen bg-black">
                    <Navbar />
                    <WelcomePopup />
                    <Routes>
                      <Route path="/" element={<Landing />} />
                      <Route path="/home" element={<Home />} />
                      <Route path="/beats" element={<BeatStore />} />
                      <Route path="/soundkits" element={<SoundKits />} />
                      <Route path="/discography" element={<Discography />} />
                      <Route path="/collaborate" element={<Collaborate />} />
                      <Route path="/mix-master" element={<MixMaster />} />
                      <Route path="/merch" element={<MerchStore />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/admin" element={<AdminLogin />} />
                      <Route path="/admin/dashboard" element={<AdminDashboard />} />
                      <Route path="/success" element={<CheckoutSuccess />} />
                      <Route path="/cancel" element={<CheckoutCancel />} />
                    </Routes>
                    <Footer />
                    <AudioPlayer />
                    <Cart />
                    <Toaster />
                  </div>
                </CartProvider>
              </AudioProvider>
            </AdminProvider>
          </AuthProvider>
        </FontProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;